import { render } from "./TraineeTaskAssessmentModal.vue?vue&type=template&id=7a8080c3&scoped=true"
import script from "./TraineeTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TraineeTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TraineeTaskAssessmentModal.vue?vue&type=style&index=0&id=7a8080c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8080c3"]])

export default __exports__